

// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Avatar, Box, Typography } from "@mui/material";
// import socket from "../socket";
// import axios from "axios";

// const API_BASE = process.env.REACT_APP_API_URL;

// const avatarColor = (name = "") => {
//   const c = ['#00C2B3', '#0088A3', '#007A70', '#005A6E'];
//   let h = 0;
//   for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
//   return c[Math.abs(h) % c.length];
// };

// const GroupChatPage = ({ currentUserId, currentUsername, currentUserPhoto }) => {
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");
//   const [onlineUsers, setOnlineUsers] = useState([]);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [groupName, setGroupName] = useState("");
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const chatEndRef = useRef(null);
//   const authHeader = { Authorization: `Bearer ${localStorage.getItem("token")}` };

//   useEffect(() => {
//     socket.on("onlineUsers", users => setOnlineUsers(users.filter(u => u.id !== currentUserId)));
//     socket.emit("joinGroups");
//     return () => socket.off("onlineUsers");
//   }, [currentUserId]);

//   useEffect(() => {
//     axios.get(`${API_BASE}/api/group`, { headers: authHeader })
//       .then(res => setGroups(res.data))
//       .catch(() => {});
//   }, [currentUserId]);

//   useEffect(() => {
//     if (!selectedGroup) return setMessages([]);
//     socket.emit("joinGroup", selectedGroup._id);
//     axios.get(`${API_BASE}/api/group/${selectedGroup._id}/messages`, { headers: authHeader })
//       .then(res => setMessages(res.data))
//       .catch(() => setMessages([]));
//     return () => socket.emit("leaveGroup", selectedGroup._id);
//   }, [selectedGroup]);

//   useEffect(() => {
//     function handleGroupMessage(msg) {
//       if (msg.groupId === selectedGroup?._id || String(msg.group) === String(selectedGroup?._id)) {
//         setMessages(prev => [...prev, {
//           _id: msg._id || Math.random().toString(36).slice(2),
//           sender: msg.sender || msg.senderId,
//           message: msg.message,
//           createdAt: msg.createdAt || new Date(),
//         }]);
//       }
//     }
//     socket.on("groupMessage", handleGroupMessage);
//     return () => socket.off("groupMessage", handleGroupMessage);
//   }, [selectedGroup]);

//   useEffect(() => {
//     chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   const sendMessage = () => {
//     if (!input.trim() || !selectedGroup) return;
//     socket.emit("groupMessage", { groupId: selectedGroup._id, message: input.trim() });
//     setInput("");
//   };

//   const handleCreateGroup = async () => {
//     if (!groupName.trim() || selectedUsers.length === 0) return alert("Provide name and select members");
//     const memberIds = [...new Set([...selectedUsers.map(String), String(currentUserId)])];
//     try {
//       const res = await axios.post(`${API_BASE}/api/group/create`, { name: groupName, members: memberIds }, { headers: authHeader });
//       setGroups(prev => [res.data, ...prev]);
//       setDialogOpen(false); setSelectedUsers([]); setGroupName("");
//     } catch { alert("Error creating group"); }
//   };

//   const handleDeleteGroup = async () => {
//     if (!window.confirm("Delete group and ALL its messages?")) return;
//     await axios.delete(`${API_BASE}/api/group/${selectedGroup._id}`, { headers: authHeader });
//     setGroups(groups.filter(g => g._id !== selectedGroup._id));
//     setSelectedGroup(null);
//   };

//   const handleLeaveGroup = async () => {
//     if (!window.confirm("Leave this group?")) return;
//     await axios.post(`${API_BASE}/api/group/${selectedGroup._id}/leave`, {}, { headers: authHeader });
//     setGroups(groups.filter(g => g._id !== selectedGroup._id));
//     setSelectedGroup(null);
//   };

//   const isCreator = selectedGroup &&
//     (String(selectedGroup?.creator?._id || selectedGroup?.creator) === String(currentUserId));

//   return (
//     <Box sx={{ display: 'flex', height: '100vh', bgcolor: '#090C0F' }}>
//       {/* Sidebar */}
//       <Box sx={{
//         width: 240, flexShrink: 0,
//         bgcolor: '#0E1318', borderRight: '1px solid #1A2228',
//         display: 'flex', flexDirection: 'column',
//       }}>
//         <Box sx={{ px: 2.5, pt: 3, pb: 2, borderBottom: '1px solid #1A2228' }}>
//           <Typography sx={{
//             fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 16,
//             color: '#F0F4F8', mb: 2,
//           }}>
//             Groups
//           </Typography>
//           <Button
//             fullWidth onClick={() => setDialogOpen(true)}
//             sx={{
//               py: 1, borderRadius: '10px', textTransform: 'none',
//               fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 13,
//               bgcolor: '#00C2B3', color: '#090C0F',
//               '&:hover': { bgcolor: '#00D5C5' },
//             }}
//           >
//             + New Group
//           </Button>
//         </Box>

//         <Box sx={{ flex: 1, overflowY: 'auto', py: 1.5, px: 1.5 }}>
//           {groups.length === 0 && (
//             <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: '#2A3A48', px: 1 }}>
//               No groups yet
//             </Typography>
//           )}
//           {groups.map(g => (
//             <Box
//               key={g._id}
//               onClick={() => setSelectedGroup(g)}
//               sx={{
//                 px: 2, py: 1.5, borderRadius: '10px', cursor: 'pointer', mb: 0.5,
//                 bgcolor: selectedGroup?._id === g._id ? '#0E2020' : 'transparent',
//                 border: `1px solid ${selectedGroup?._id === g._id ? '#0A3530' : 'transparent'}`,
//                 '&:hover': { bgcolor: '#111820' },
//               }}
//             >
//               <Typography sx={{
//                 fontFamily: "'Outfit', sans-serif", fontSize: 14,
//                 fontWeight: selectedGroup?._id === g._id ? 600 : 400,
//                 color: selectedGroup?._id === g._id ? '#00C2B3' : '#A0B0BF',
//               }}>
//                 # {g.name}
//               </Typography>
//               <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: '#2A3A48' }}>
//                 {g.members?.length || 0} members
//               </Typography>
//             </Box>
//           ))}
//         </Box>
//       </Box>

//       {/* Chat panel */}
//       <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
//         {selectedGroup ? (
//           <>
//             {/* Header */}
//             <Box sx={{
//               px: 3, py: 2, bgcolor: '#0E1318', borderBottom: '1px solid #1A2228',
//               display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//             }}>
//               <Box>
//                 <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 16, color: '#F0F4F8' }}>
//                   # {selectedGroup.name}
//                 </Typography>
//                 <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: '#3A4A58' }}>
//                   {selectedGroup.members?.length || 0} members
//                 </Typography>
//               </Box>
//               <Button
//                 onClick={isCreator ? handleDeleteGroup : handleLeaveGroup}
//                 size="small"
//                 sx={{
//                   textTransform: 'none', fontFamily: "'Outfit', sans-serif", fontSize: 12,
//                   color: isCreator ? '#FF6B6B' : '#F0A830',
//                   border: `1px solid ${isCreator ? '#2A1515' : '#2A2010'}`,
//                   borderRadius: '8px', px: 2,
//                   '&:hover': { bgcolor: isCreator ? '#1A0E0E' : '#1A1810' },
//                 }}
//               >
//                 {isCreator ? 'Delete' : 'Leave'}
//               </Button>
//             </Box>

//             {/* Messages */}
//             <Box sx={{
//               flex: 1, overflowY: 'auto', px: 3, py: 2,
//               display: 'flex', flexDirection: 'column', gap: 1,
//               '&::-webkit-scrollbar': { width: 4 },
//               '&::-webkit-scrollbar-thumb': { bgcolor: '#1A2228', borderRadius: 4 },
//             }}>
//               {messages.map((m, idx) => {
//                 const senderId = m.sender?._id ? String(m.sender._id) : String(m.sender);
//                 const senderName = m.sender?.username || currentUsername;
//                 const isMine = senderId === String(currentUserId);

//                 return (
//                   <Box key={idx} sx={{
//                     display: 'flex', justifyContent: isMine ? 'flex-end' : 'flex-start',
//                   }}>
//                     <Box sx={{ display: 'flex', flexDirection: isMine ? 'row-reverse' : 'row', alignItems: 'flex-end', gap: 1, maxWidth: '65%' }}>
//                       <Avatar sx={{
//                         width: 28, height: 28, fontSize: 11, fontWeight: 700,
//                         bgcolor: avatarColor(isMine ? currentUsername : senderName),
//                         mb: 0.5, flexShrink: 0,
//                       }}>
//                         {(isMine ? currentUsername : senderName)?.[0]?.toUpperCase()}
//                       </Avatar>
//                       <Box sx={{
//                         bgcolor: isMine ? '#0E2020' : '#0E1318',
//                         border: `1px solid ${isMine ? '#0A3530' : '#1A2228'}`,
//                         borderRadius: isMine ? '12px 4px 12px 12px' : '4px 12px 12px 12px',
//                         px: 2, py: 1.2,
//                       }}>
//                         <Typography sx={{
//                           fontFamily: "'Outfit', sans-serif", fontSize: 12, fontWeight: 600,
//                           color: isMine ? '#00C2B3' : '#7A9BAA', mb: 0.4,
//                         }}>
//                           {isMine ? 'You' : senderName}
//                         </Typography>
//                         <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8', lineHeight: 1.5 }}>
//                           {m.message}
//                         </Typography>
//                         <Typography sx={{
//                           fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
//                           color: '#2A3A48', mt: 0.5, textAlign: isMine ? 'right' : 'left',
//                         }}>
//                           {m.createdAt ? new Date(m.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Box>
//                 );
//               })}
//               <div ref={chatEndRef} />
//             </Box>

//             {/* Input */}
//             <Box sx={{
//               px: 3, py: 2, bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
//               display: 'flex', gap: 1.5,
//             }}>
//               <Box sx={{
//                 flex: 1, bgcolor: '#141B22', border: '1px solid #1A2228',
//                 borderRadius: '12px', display: 'flex', alignItems: 'center',
//                 '&:focus-within': { borderColor: '#00C2B3' },
//               }}>
//                 <TextField
//                   fullWidth placeholder={`Message #${selectedGroup.name}...`}
//                   value={input}
//                   onChange={e => setInput(e.target.value)}
//                   onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
//                   variant="standard"
//                   InputProps={{ disableUnderline: true }}
//                   sx={{
//                     px: 2, py: 1,
//                     '& .MuiInputBase-root': { fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8' },
//                     '& ::placeholder': { color: '#2A3A48' },
//                   }}
//                 />
//               </Box>
//               <Button
//                 onClick={sendMessage}
//                 disabled={!input.trim()}
//                 sx={{
//                   minWidth: 42, height: 42, borderRadius: '10px',
//                   bgcolor: input.trim() ? '#00C2B3' : '#141B22',
//                   border: `1px solid ${input.trim() ? '#00C2B3' : '#1A2228'}`,
//                   color: input.trim() ? '#090C0F' : '#2A3A48',
//                   p: 0,
//                   '&:hover': { bgcolor: input.trim() ? '#00D5C5' : '#1A2530' },
//                   '&.Mui-disabled': { bgcolor: '#141B22', borderColor: '#1A2228' },
//                 }}
//               >
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//                   <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                 </svg>
//               </Button>
//             </Box>
//           </>
//         ) : (
//           <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
//             <Box sx={{
//               width: 64, height: 64, borderRadius: '16px',
//               bgcolor: '#0E1318', border: '1px solid #1A2228',
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//             }}>
//               <Typography sx={{ fontSize: 28 }}>👥</Typography>
//             </Box>
//             <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 16, color: '#3A4A58', fontWeight: 500 }}>
//               Select a group to start chatting
//             </Typography>
//           </Box>
//         )}
//       </Box>

//       {/* Create Group Dialog */}
//       <Dialog
//         open={dialogOpen}
//         onClose={() => { setDialogOpen(false); setSelectedUsers([]); setGroupName(""); }}
//         PaperProps={{
//           sx: {
//             bgcolor: '#0E1318', border: '1px solid #1A2228',
//             borderRadius: '16px', minWidth: 360,
//           }
//         }}
//       >
//         <DialogTitle sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, color: '#F0F4F8', fontSize: 18 }}>
//           Create group
//         </DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus margin="dense" label="Group name" fullWidth
//             value={groupName} onChange={e => setGroupName(e.target.value)}
//             variant="filled"
//             sx={{
//               mb: 3,
//               '& .MuiFilledInput-root': {
//                 bgcolor: '#141B22', borderRadius: '10px', border: '1px solid #1A2228',
//                 '&::before, &::after': { display: 'none' },
//                 '&.Mui-focused': { borderColor: '#00C2B3' },
//               },
//               '& .MuiFilledInput-input': { color: '#F0F4F8', fontFamily: "'Outfit', sans-serif" },
//               '& .MuiInputLabel-root': { color: '#3A4A58', fontFamily: "'Outfit', sans-serif", '&.Mui-focused': { color: '#00C2B3' } },
//             }}
//           />
//           <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 13, color: '#A0B0BF', mb: 1.5, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
//             Add members
//           </Typography>
//           {onlineUsers.length === 0 ? (
//             <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#2A3A48' }}>
//               No other users online
//             </Typography>
//           ) : (
//             onlineUsers.map(user => (
//               <Box
//                 key={user.id}
//                 onClick={() => setSelectedUsers(prev =>
//                   prev.includes(user.id) ? prev.filter(id => id !== user.id) : [...prev, user.id]
//                 )}
//                 sx={{
//                   display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5,
//                   borderRadius: '10px', cursor: 'pointer', mb: 0.5,
//                   bgcolor: selectedUsers.includes(user.id) ? '#0E2020' : 'transparent',
//                   border: `1px solid ${selectedUsers.includes(user.id) ? '#0A3530' : 'transparent'}`,
//                   '&:hover': { bgcolor: '#111820' },
//                 }}
//               >
//                 <Avatar sx={{ width: 30, height: 30, fontSize: 12, bgcolor: avatarColor(user.username) }}>
//                   {user.username?.[0]?.toUpperCase()}
//                 </Avatar>
//                 <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#F0F4F8', flex: 1 }}>
//                   {user.username}
//                 </Typography>
//                 {selectedUsers.includes(user.id) && (
//                   <Box sx={{ width: 16, height: 16, borderRadius: '50%', bgcolor: '#00C2B3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <svg width="9" height="9" viewBox="0 0 10 10" fill="none">
//                       <path d="M2 5L4 7L8 3" stroke="#090C0F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//                     </svg>
//                   </Box>
//                 )}
//               </Box>
//             ))
//           )}
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//           <Button
//             onClick={() => { setDialogOpen(false); setSelectedUsers([]); setGroupName(""); }}
//             sx={{ fontFamily: "'Outfit', sans-serif", color: '#3A4A58', textTransform: 'none', '&:hover': { color: '#F0F4F8' } }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleCreateGroup}
//             sx={{
//               fontFamily: "'Outfit', sans-serif", fontWeight: 600, textTransform: 'none',
//               bgcolor: '#00C2B3', color: '#090C0F', borderRadius: '10px', px: 3,
//               '&:hover': { bgcolor: '#00D5C5' },
//             }}
//           >
//             Create
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default GroupChatPage;


import React, { useEffect, useState, useRef } from "react";
import {
  Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions,
  Avatar, Box, Typography, IconButton, Tooltip, Drawer,
  useTheme, useMediaQuery,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MenuIcon from "@mui/icons-material/Menu";
import socket from "../socket";
import axios from "axios";
import { triggerNotification } from "./NotificationSystem";

const API_BASE = process.env.REACT_APP_API_URL;

const avatarColor = (name = "") => {
  const c = ['#00C2B3', '#0088A3', '#007A70', '#005A6E'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return c[Math.abs(h) % c.length];
};

const getAvatarUrl = (photo) => {
  if (!photo) return undefined;
  if (photo.startsWith('http')) return photo;
  return `${API_BASE.replace(/\/+$/, '')}/${photo.replace(/^\/+/, '')}`;
};

const FilePreview = ({ fileUrl }) => {
  const url = `${API_BASE}${fileUrl}`;
  const name = fileUrl.split('/').pop();
  const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(fileUrl);
  const isVideo = /\.(mp4|mov|webm)$/i.test(fileUrl);
  const isAudio = /\.(mp3|wav|ogg)$/i.test(fileUrl);
  if (isImage) return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <img src={url} alt={name} style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8, display: 'block', cursor: 'zoom-in' }} />
    </a>
  );
  if (isVideo) return <video src={url} controls style={{ maxWidth: '100%', borderRadius: 8 }} />;
  if (isAudio) return <audio src={url} controls style={{ width: '100%' }} />;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      style={{ color: '#00C2B3', textDecoration: 'none', fontFamily: "'Outfit', sans-serif", fontSize: 14 }}>
      📎 {name}
    </a>
  );
};

const GroupChatPage = ({ currentUserId, currentUsername, currentUserPhoto }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const authHeader = { Authorization: `Bearer ${localStorage.getItem("token")}` };

  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [hoveredMsg, setHoveredMsg] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const chatEndRef = useRef(null);
  const fileInputRef = useRef();

  useEffect(() => {
    socket.on("onlineUsers", users =>
      setOnlineUsers(users.filter(u => String(u.id) !== String(currentUserId)))
    );
    socket.emit("joinGroups");
    return () => socket.off("onlineUsers");
  }, [currentUserId]);

  useEffect(() => {
    axios.get(`${API_BASE}/api/group`, { headers: authHeader })
      .then(res => setGroups(res.data))
      .catch(() => {});
  }, [currentUserId]);

  useEffect(() => {
    if (!selectedGroup) return setMessages([]);
    socket.emit("joinGroup", selectedGroup._id);
    axios.get(`${API_BASE}/api/group/${selectedGroup._id}/messages`, { headers: authHeader })
      .then(res => setMessages(res.data))
      .catch(() => setMessages([]));
    return () => socket.emit("leaveGroup", selectedGroup._id);
  }, [selectedGroup]);

  useEffect(() => {
    function handleGroupMessage(msg) {
      if (msg.groupId === selectedGroup?._id || String(msg.group) === String(selectedGroup?._id)) {
        setMessages(prev => {
          if (prev.some(m => m._id && String(m._id) === String(msg._id))) return prev;
          return [...prev, {
            _id: msg._id || Math.random().toString(36).slice(2),
            sender: msg.sender || msg.senderId,
            message: msg.message,
            fileUrl: msg.fileUrl,
            createdAt: msg.createdAt || new Date(),
          }];
        });
        const senderId = msg.sender?._id ? String(msg.sender._id) : String(msg.sender);
        if (senderId !== String(currentUserId)) {
          triggerNotification({
            from: msg.sender?.username || 'Someone',
            channel: `#${selectedGroup?.name}`,
            message: msg.message || '📎 File',
          });
        }
      }
    }

    function handleGroupMessageDeleted({ messageId }) {
      setMessages(prev => prev.filter(m => String(m._id) !== String(messageId)));
    }

    socket.on("groupMessage", handleGroupMessage);
    socket.on("groupMessageDeleted", handleGroupMessageDeleted);
    return () => {
      socket.off("groupMessage", handleGroupMessage);
      socket.off("groupMessageDeleted", handleGroupMessageDeleted);
    };
  }, [selectedGroup, currentUserId]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = () => {
    if (!input.trim() || !selectedGroup) return;
    socket.emit("groupMessage", { groupId: selectedGroup._id, message: input.trim() });
    setInput("");
  };

  const handleFileSelect = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    setFilePreview(f.type.startsWith('image/') ? URL.createObjectURL(f) : null);
  };

  const clearFile = () => {
    setFile(null); setFilePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const sendFile = async () => {
    if (!file || !selectedGroup) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await axios.post(`${API_BASE}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data", ...authHeader },
      });
      socket.emit("groupMessage", {
        groupId: selectedGroup._id,
        message: "",
        fileUrl: res.data.fileUrl,
      });
      clearFile();
    } catch (err) {
      console.error("File upload failed", err);
    } finally {
      setUploading(false);
    }
  };

  const deleteMessage = (msgId) => {
    socket.emit("deleteGroupMessage", { messageId: msgId, groupId: selectedGroup._id });
  };

  const handleCreateGroup = async () => {
    if (!groupName.trim() || selectedUsers.length === 0) return alert("Provide name and select members");
    const memberIds = [...new Set([...selectedUsers.map(String), String(currentUserId)])];
    try {
      const res = await axios.post(`${API_BASE}/api/group/create`, { name: groupName, members: memberIds }, { headers: authHeader });
      setGroups(prev => [res.data, ...prev]);
      setDialogOpen(false); setSelectedUsers([]); setGroupName("");
    } catch { alert("Error creating group"); }
  };

  const handleDeleteGroup = async () => {
    if (!window.confirm("Delete group and ALL its messages?")) return;
    await axios.delete(`${API_BASE}/api/group/${selectedGroup._id}`, { headers: authHeader });
    setGroups(groups.filter(g => g._id !== selectedGroup._id));
    setSelectedGroup(null);
  };

  const handleLeaveGroup = async () => {
    if (!window.confirm("Leave this group?")) return;
    await axios.post(`${API_BASE}/api/group/${selectedGroup._id}/leave`, {}, { headers: authHeader });
    setGroups(groups.filter(g => g._id !== selectedGroup._id));
    setSelectedGroup(null);
  };

  const isCreator = selectedGroup &&
    String(selectedGroup?.creator?._id || selectedGroup?.creator) === String(currentUserId);

  const groupSidebar = (
    <Box sx={{
      width: 240, bgcolor: '#0E1318',
      borderRight: !isMobile ? '1px solid #1A2228' : 'none',
      display: 'flex', flexDirection: 'column', height: '100%',
    }}>
      <Box sx={{ px: 2.5, pt: 2.5, pb: 2, borderBottom: '1px solid #1A2228' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 16, color: '#F0F4F8' }}>
            Groups
          </Typography>
          {isMobile && (
            <IconButton size="small" onClick={() => setSidebarOpen(false)} sx={{ color: '#5A6A78' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
        <Button
          fullWidth onClick={() => setDialogOpen(true)}
          sx={{
            py: 0.9, borderRadius: '10px', textTransform: 'none',
            fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 13,
            bgcolor: '#00C2B3', color: '#090C0F',
            '&:hover': { bgcolor: '#00D5C5' },
          }}
        >
          + New Group
        </Button>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', py: 1.5, px: 1.5 }}>
        {groups.length === 0 && (
          <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: '#2A3A48', px: 1 }}>
            No groups yet
          </Typography>
        )}
        {groups.map(g => (
          <Box
            key={g._id}
            onClick={() => { setSelectedGroup(g); if (isMobile) setSidebarOpen(false); }}
            sx={{
              px: 2, py: 1.5, borderRadius: '10px', cursor: 'pointer', mb: 0.5,
              bgcolor: selectedGroup?._id === g._id ? '#0E2020' : 'transparent',
              border: `1px solid ${selectedGroup?._id === g._id ? '#0A3530' : 'transparent'}`,
              '&:hover': { bgcolor: '#111820' },
            }}
          >
            <Typography sx={{
              fontFamily: "'Outfit', sans-serif", fontSize: 14,
              fontWeight: selectedGroup?._id === g._id ? 600 : 400,
              color: selectedGroup?._id === g._id ? '#00C2B3' : '#A0B0BF',
            }}>
              # {g.name}
            </Typography>
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: '#2A3A48' }}>
              {g.members?.length || 0} members
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex', height: '100vh', bgcolor: '#090C0F', pt: '56px' }}>
      {/* Desktop sidebar */}
      {!isMobile && groupSidebar}

      {/* Mobile drawer */}
      {isMobile && (
        <Drawer anchor="left" open={sidebarOpen} onClose={() => setSidebarOpen(false)}
          PaperProps={{ sx: { bgcolor: '#090C0F', top: '56px' } }}>
          {groupSidebar}
        </Drawer>
      )}

      {/* Chat panel */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {selectedGroup ? (
          <>
            {/* Header */}
            <Box sx={{
              px: { xs: 2, sm: 3 }, py: 1.5,
              bgcolor: '#0E1318', borderBottom: '1px solid #1A2228',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {isMobile && (
                  <IconButton onClick={() => setSidebarOpen(true)} sx={{ color: '#5A6A78', p: 0.5 }}>
                    <MenuIcon fontSize="small" />
                  </IconButton>
                )}
                <Box>
                  <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 15, color: '#F0F4F8' }}>
                    # {selectedGroup.name}
                  </Typography>
                  <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: '#3A4A58' }}>
                    {selectedGroup.members?.length || 0} members
                  </Typography>
                </Box>
              </Box>
              <Button
                onClick={isCreator ? handleDeleteGroup : handleLeaveGroup}
                size="small"
                sx={{
                  textTransform: 'none', fontFamily: "'Outfit', sans-serif", fontSize: 12,
                  color: isCreator ? '#FF6B6B' : '#F0A830',
                  border: `1px solid ${isCreator ? '#2A1515' : '#2A2010'}`,
                  borderRadius: '8px', px: 2,
                  '&:hover': { bgcolor: isCreator ? '#1A0E0E' : '#1A1810' },
                }}
              >
                {isCreator ? 'Delete' : 'Leave'}
              </Button>
            </Box>

            {/* Messages */}
            <Box sx={{
              flex: 1, overflowY: 'auto', px: { xs: 1.5, sm: 3 }, py: 2,
              '&::-webkit-scrollbar': { width: 4 },
              '&::-webkit-scrollbar-thumb': { bgcolor: '#1A2228', borderRadius: 4 },
            }}>
              {messages.map((m, idx) => {
                const senderId = m.sender?._id ? String(m.sender._id) : String(m.sender);
                const senderName = m.sender?.username || currentUsername;
                const isMine = senderId === String(currentUserId);

                return (
                  <Box
                    key={m._id || idx}
                    onMouseEnter={() => setHoveredMsg(m._id)}
                    onMouseLeave={() => setHoveredMsg(null)}
                    sx={{ display: 'flex', justifyContent: isMine ? 'flex-end' : 'flex-start', mb: 1.5 }}
                  >
                    <Box sx={{
                      display: 'flex', flexDirection: isMine ? 'row-reverse' : 'row',
                      alignItems: 'flex-end', gap: 1,
                      maxWidth: { xs: '85%', sm: '65%' },
                    }}>
                      <Avatar
                        src={isMine ? getAvatarUrl(currentUserPhoto) : getAvatarUrl(m.sender?.profilePhoto)}
                        sx={{ width: 28, height: 28, fontSize: 11, fontWeight: 700, bgcolor: avatarColor(senderName), mb: 0.5, flexShrink: 0 }}
                      >
                        {(isMine ? currentUsername : senderName)?.[0]?.toUpperCase()}
                      </Avatar>

                      <Box sx={{
                        bgcolor: isMine ? '#0E2020' : '#0E1318',
                        border: `1px solid ${isMine ? '#0A3530' : '#1A2228'}`,
                        borderRadius: isMine ? '12px 4px 12px 12px' : '4px 12px 12px 12px',
                        px: 2, py: 1.2,
                      }}>
                        <Typography sx={{
                          fontFamily: "'Outfit', sans-serif", fontSize: 12, fontWeight: 600,
                          color: isMine ? '#00C2B3' : '#7A9BAA', mb: 0.4,
                        }}>
                          {isMine ? 'You' : senderName}
                        </Typography>
                        {m.message && (
                          <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8', lineHeight: 1.5, wordBreak: 'break-word' }}>
                            {m.message}
                          </Typography>
                        )}
                        {m.fileUrl && <FilePreview fileUrl={m.fileUrl} />}
                        <Typography sx={{
                          fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: '#2A3A48',
                          mt: 0.5, textAlign: isMine ? 'right' : 'left',
                        }}>
                          {m.createdAt ? new Date(m.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                        </Typography>
                      </Box>

                      {isMine && m._id && hoveredMsg === m._id && (
                        <Tooltip title="Delete" placement="top">
                          <IconButton
                            size="small"
                            onClick={() => deleteMessage(m._id)}
                            sx={{ color: '#FF6B6B', p: 0.3, '&:hover': { bgcolor: '#1A0E0E' } }}
                          >
                            <DeleteOutlineIcon sx={{ fontSize: 15 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </Box>
                );
              })}
              <div ref={chatEndRef} />
            </Box>

            {/* File preview strip */}
            {file && (
              <Box sx={{
                px: 3, py: 1.5, bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
                display: 'flex', alignItems: 'center', gap: 2,
              }}>
                {filePreview
                  ? <img src={filePreview} alt="preview" style={{ height: 52, width: 52, objectFit: 'cover', borderRadius: 8 }} />
                  : <Box sx={{ width: 52, height: 52, bgcolor: '#141B22', border: '1px solid #1A2228', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Typography sx={{ fontSize: 20 }}>📎</Typography>
                    </Box>
                }
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#F0F4F8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {file.name}
                  </Typography>
                </Box>
                <Button onClick={sendFile} disabled={uploading}
                  sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, textTransform: 'none', bgcolor: '#00C2B3', color: '#090C0F', borderRadius: '8px', px: 2, py: 0.8 }}>
                  {uploading ? 'Sending...' : 'Send'}
                </Button>
                <IconButton onClick={clearFile} size="small" sx={{ color: '#FF6B6B' }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )}

            {/* Input */}
            <Box sx={{
              px: { xs: 1.5, sm: 3 }, py: 1.5,
              bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
              display: 'flex', gap: 1.5, alignItems: 'flex-end', flexShrink: 0,
            }}>
              <IconButton component="label"
                sx={{
                  width: 38, height: 38, borderRadius: '10px',
                  bgcolor: '#141B22', border: '1px solid #1A2228', color: '#4A6070', flexShrink: 0,
                  '&:hover': { bgcolor: '#1A2530', color: '#00C2B3', borderColor: '#00C2B3' },
                }}
              >
                <AttachFileIcon sx={{ fontSize: 18 }} />
                <input type="file" hidden ref={fileInputRef} onChange={handleFileSelect} />
              </IconButton>

              <Box sx={{
                flex: 1, bgcolor: '#141B22', border: '1px solid #1A2228', borderRadius: '12px',
                '&:focus-within': { borderColor: '#00C2B3' },
              }}>
                <TextField
                  fullWidth placeholder={`Message #${selectedGroup.name}...`}
                  value={input}
                  onChange={e => setInput(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
                  variant="standard"
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    px: 2, py: 1,
                    '& .MuiInputBase-root': { fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8' },
                    '& textarea::placeholder': { color: '#2A3A48', opacity: 1 },
                  }}
                />
              </Box>

              <IconButton
                onClick={sendMessage}
                disabled={!input.trim()}
                sx={{
                  width: 38, height: 38, borderRadius: '10px', flexShrink: 0,
                  bgcolor: input.trim() ? '#00C2B3' : '#141B22',
                  border: `1px solid ${input.trim() ? '#00C2B3' : '#1A2228'}`,
                  color: input.trim() ? '#090C0F' : '#2A3A48',
                  '&:hover': { bgcolor: input.trim() ? '#00D5C5' : '#1A2530' },
                  '&.Mui-disabled': { bgcolor: '#141B22', borderColor: '#1A2228', color: '#2A3A48' },
                }}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                  <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </IconButton>
            </Box>
          </>
        ) : (
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
            {isMobile && (
              <Button onClick={() => setSidebarOpen(true)}
                sx={{ fontFamily: "'Outfit', sans-serif", textTransform: 'none', color: '#00C2B3', fontSize: 14 }}>
                ← View groups
              </Button>
            )}
            <Box sx={{ width: 60, height: 60, borderRadius: '16px', bgcolor: '#0E1318', border: '1px solid #1A2228', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography sx={{ fontSize: 26 }}>👥</Typography>
            </Box>
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 15, color: '#3A4A58' }}>
              Select a group to start chatting
            </Typography>
          </Box>
        )}
      </Box>

      {/* Create Group Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={() => { setDialogOpen(false); setSelectedUsers([]); setGroupName(""); }}
        PaperProps={{ sx: { bgcolor: '#0E1318', border: '1px solid #1A2228', borderRadius: '16px', minWidth: { xs: '90vw', sm: 360 } } }}
      >
        <DialogTitle sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, color: '#F0F4F8', fontSize: 18 }}>
          Create group
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus margin="dense" label="Group name" fullWidth
            value={groupName} onChange={e => setGroupName(e.target.value)}
            variant="filled"
            sx={{
              mb: 2.5,
              '& .MuiFilledInput-root': {
                bgcolor: '#141B22', borderRadius: '10px', border: '1px solid #1A2228',
                '&::before, &::after': { display: 'none' },
                '&.Mui-focused': { borderColor: '#00C2B3' },
              },
              '& .MuiFilledInput-input': { color: '#F0F4F8', fontFamily: "'Outfit', sans-serif" },
              '& .MuiInputLabel-root': { color: '#3A4A58', fontFamily: "'Outfit', sans-serif", '&.Mui-focused': { color: '#00C2B3' } },
            }}
          />
          <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 12, color: '#5A6A78', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 1.5 }}>
            Add members ({onlineUsers.length} online)
          </Typography>
          {onlineUsers.length === 0 ? (
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#2A3A48' }}>No other users online</Typography>
          ) : (
            onlineUsers.map(user => (
              <Box
                key={user.id}
                onClick={() => setSelectedUsers(prev =>
                  prev.includes(user.id) ? prev.filter(id => id !== user.id) : [...prev, user.id]
                )}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 1.5, p: 1.2,
                  borderRadius: '10px', cursor: 'pointer', mb: 0.5,
                  bgcolor: selectedUsers.includes(user.id) ? '#0E2020' : 'transparent',
                  border: `1px solid ${selectedUsers.includes(user.id) ? '#0A3530' : 'transparent'}`,
                  '&:hover': { bgcolor: '#111820' },
                }}
              >
                <Avatar
                  src={getAvatarUrl(user.profilePhoto)}
                  sx={{ width: 32, height: 32, fontSize: 12, bgcolor: avatarColor(user.username) }}
                >
                  {!user.profilePhoto && user.username?.[0]?.toUpperCase()}
                </Avatar>
                <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#F0F4F8', flex: 1 }}>
                  {user.username}
                </Typography>
                {selectedUsers.includes(user.id) && (
                  <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: '#00C2B3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path d="M2 5L4 7L8 3" stroke="#090C0F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </Box>
                )}
              </Box>
            ))
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={() => { setDialogOpen(false); setSelectedUsers([]); setGroupName(""); }}
            sx={{ fontFamily: "'Outfit', sans-serif", color: '#3A4A58', textTransform: 'none', '&:hover': { color: '#F0F4F8' } }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCreateGroup}
            sx={{
              fontFamily: "'Outfit', sans-serif", fontWeight: 600, textTransform: 'none',
              bgcolor: '#00C2B3', color: '#090C0F', borderRadius: '10px', px: 3,
              '&:hover': { bgcolor: '#00D5C5' },
            }}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default GroupChatPage;